'use client';

import Markdown from 'markdown-to-jsx';

const Heading1 = ({ children }) => <h1 className="card-title">{children}</h1>;
const Heading2 = ({ children }) => <h2 className="card-title">{children}</h2>;
const Heading3 = ({ children }) => <h3 className="card-title">{children}</h3>;
const Heading4 = ({ children }) => <h4 className="card-title">{children}</h4>;
const Heading5 = ({ children }) => <h5 className="card-title">{children}</h5>;

const Paragraph = ({ children }) => <p className="text-dark mt-3" align="justify">{children}</p>;

const Dl = ({ children }) => <dl className="row text-dark mt-3">{children}</dl>;
const Dd = ({ children }) => <dd className="col-sm-9">{children}</dd>;
const Dt = ({ children }) => <dt className="col-sm-3">{children}</dt>;

const Ol = ({ children }) => (
  <ol className="text-dark">{children}</ol>
);

const Ul = ({ children }) => (
  <ul className="text-dark">
    {children}
  </ul>
);

function MarkdownContent({ text }) {
  return (
    <Markdown options={{
      overrides: {
        h1: Heading1,
        h2: Heading2,
        h3: Heading3,
        h4: Heading4,
        h5: Heading5,
        p: Paragraph,
        ol: Ol,
        ul: Ul,
        dl: Dl,
        dt: Dt,
        dd: Dd,
      },
    }}
    >
      {text}
    </Markdown>
  );
}

export default MarkdownContent;
